import React from 'react'
import { Header, Text } from '@crossfit/ui'

import InnerContent from 'components/InnerContent'

function NotAuthorized() {
  return (
    <InnerContent>
      <Header as='h2' size='large' mb={2}>
        Sorry
      </Header>
      <Text>You do not have access to this content.</Text>
    </InnerContent>
  )
}

export default NotAuthorized
